<template>
  <section>
    <header ref="header" :class="{ isMobile: isMobile }" class="header">
      <client-only>
        <GlobalMessage @watchChange="resetHeaderBackdropHeight" />
      </client-only>
      <section v-if="!isMobile" class="header-social-lang">
        <div class="wrap-block header-social-lang-block">
          <nuxt-link
            v-if="user"
            class="header-social-link"
            to="/user/inbox"
            :title="$t('common.titles.inbox')"
          >
            <i class="mc-inbox"></i>
          </nuxt-link>
          <a class="header-social-link" href="#" @click.prevent="openCSRWidget">
            <i class="mc-support"></i>
          </a>
          <template
            v-for="mainMenuSocialMediaListItem in compMainMenuSocialMediaList"
          >
            <a
              v-if="mainMenuSocialMediaListItem.enable"
              :key="mainMenuSocialMediaListItem.type"
              class="header-social-link"
              target="_blank"
              :href="mainMenuSocialMediaListItem.link"
            >
              <i :class="`mc-${mainMenuSocialMediaListItem.type}`"></i>
            </a>
          </template>
          <div
            :class="{ active: showSwitchLocaleContent }"
            class="d-lg-flex d-none header-lang"
            @click.prevent="showSwitchLocaleContent = !showSwitchLocaleContent"
          >
            <div
              :class="{ active: showSwitchLocaleContent }"
              class="header-lang-btn-switch-locale"
            >
              <div class="header-lang-btn-switch-locale-block">
                <i class="mc-lang header-lang-btn-switch-locale-icon"></i>
                <span
                  class="header-lang-btn-switch-locale-text"
                  :class="{ active: showSwitchLocaleContent }"
                >
                  {{ $t(`locales.${locale}`) }}
                </span>
              </div>
              <template v-for="localeItem in locales">
                <div
                  v-if="localeItem !== locale"
                  :key="localeItem"
                  class="header-lang-btn-switch-locale-other"
                  :class="{ active: showSwitchLocaleContent }"
                  @click.prevent="switchLocale(localeItem)"
                >
                  <span class="header-lang-btn-switch-locale-text">{{
                    $t(`locales.${localeItem}`)
                  }}</span>
                </div>
              </template>
            </div>
          </div>
          <button v-if="user" class="header-log-out" @click.prevent="logout()">
            <i class="mc-sign-out"></i>
            <span>{{ $t('layout.Header.list.logOut') }}</span>
          </button>
        </div>
      </section>
      <section class="header-main" :class="{ user: user }">
        <div
          v-if="!isMobile"
          class="wrap-block w-100 d-flex align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center ">
            <nuxt-link
              v-if="$route.path === '/'"
              to="/"
              class="header-main-logo logo"
            >
              <h1
                :style="{
                  backgroundImage: `url(https://ik.imagekit.io/1pzxddx3qqv/Z54IV3/static/${templateId}/${compId}/header-logo.png)`
                }"
                class="text-unshow logo-link"
              >
                {{ title }}
              </h1>
            </nuxt-link>
            <nuxt-link v-else to="/" class="header-main-logo logo">
              <div
                :style="{
                  backgroundImage: `url(https://ik.imagekit.io/1pzxddx3qqv/Z54IV3/static/${templateId}/${compId}/header-logo.png)`
                }"
                class="text-unshow logo-link"
              >
                {{ compName }}
              </div>
            </nuxt-link>
            <nav id="nav-tab" role="tablist" class="nav header-main-menu">
              <template
                v-for="(mainMenuFirstListItem, idx) in mainMenuFirstList"
              >
                <button
                  v-if="!mainMenuFirstListItem.link"
                  :id="`header-main-menu-` + mainMenuFirstListItem.type"
                  :key="idx"
                  ref="headerMainMenuLink"
                  data-bs-toggle="tab"
                  :data-bs-target="
                    `#HeaderMainMenu${capitalizeFirstWord(
                      mainMenuFirstListItem.type
                    )}`
                  "
                  :aria-controls="
                    `HeaderMainMenu${capitalizeFirstWord(
                      mainMenuFirstListItem.type
                    )}`
                  "
                  :aria-selected="
                    `HeaderMainMenu${capitalizeFirstWord(
                      mainMenuFirstListItem.type
                    )}`
                  "
                  class="nav-link header-main-menu-link"
                >
                  {{ $t(`layout.Header.list.${mainMenuFirstListItem.type}`) }}
                </button>
                <button
                  v-else
                  :key="idx"
                  class="nav-link header-main-menu-link"
                  @click.prevent="
                    ;[
                      $router.push(`${mainMenuFirstListItem.link}`),
                      closeMainMenu()
                    ]
                  "
                >
                  {{ $t(`layout.Header.list.${mainMenuFirstListItem.type}`) }}
                </button>
              </template>
              <section
                ref="headerMainMenu"
                class="tab-content tab-content-main header-main-menu-content"
              >
                <HeaderMenu
                  id="HeaderMainMenuGame"
                  target-id="header-main-menu-game"
                  :menu-data="compMainMenuSecondaryGameList"
                />
                <HeaderMenu
                  v-if="user"
                  id="HeaderMainMenuWallet"
                  target-id="header-main-menu-wallet"
                  :menu-data="compMenuSecondaryWalletList"
                />
                <HeaderMenu
                  id="HeaderMainMenuSupport"
                  target-id="header-main-menu-support"
                  :menu-data="compMainMenuSecondarySupportList"
                />
              </section>
            </nav>
          </div>
          <div class="header-main-btn">
            <template v-if="!user">
              <button class="btn btn-secondary" @click="showAuthModal('login')">
                {{ $t('common.login') }}
              </button>
              <button class="btn btn-primary" @click="showAuthModal('signUp')">
                {{ $t('common.signUp') }}
              </button>
            </template>
            <template v-else>
              <nuxt-link to="/user" class="d-flex">
                <div
                  v-if="compCommon.vip.enable"
                  class="header-main-menu-level-pic"
                >
                  <img
                    :src="
                      `https://ik.imagekit.io/1pzxddx3qqv/Z54IV3/static/${templateId}/${compId}/level/user-level-lv-` +
                        user.level +
                        '.png'
                    "
                    :alt="`user-level-lv-${user.level}`"
                  />
                </div>
                <div class="header-main-menu-user-info">
                  <h6 class="mb-2 main-menu-header-info-name">
                    {{ maskUsername }}
                  </h6>
                  <h3 class="main-menu-header-info-wallet">
                    {{ currencySymbol }}
                    {{ currency(user.wallet) }}
                  </h3>
                </div>
              </nuxt-link>
              <nuxt-link
                to="/user/financial-service/deposit"
                class="btn btn-primary"
              >
                {{ $t('layout.Header.list.deposit') }}
              </nuxt-link>
            </template>
          </div>
        </div>
        <div
          v-if="isMobile"
          class="d-flex align-items-center justify-content-end w-100 "
          :class="{ 'justify-content-between': user }"
        >
          <nuxt-link v-if="user" to="/user/account-setting/personal-data"
            ><i class="mc-setting header-main-icon"></i
          ></nuxt-link>
          <nuxt-link to="/" class="header-main-logo logo">
            <h1
              :style="{
                backgroundImage: `url(https://ik.imagekit.io/1pzxddx3qqv/Z54IV3/static/${templateId}/${compId}/header-logo.png)`
              }"
              class="text-unshow logo-link"
            >
              {{ title }}
            </h1>
          </nuxt-link>
          <div v-if="user" class="d-flex align-items-center">
            <nuxt-link to="/user/inbox">
              <i class="mc-inbox header-main-icon"></i>
            </nuxt-link>
            <a href="#" @click.prevent="openCSRWidget">
              <i class="mc-support header-main-icon"></i>
            </a>
          </div>
          <button
            v-else
            class="btn btn-secondary-outline header-main-login"
            @click="showAuthModal('login')"
          >
            {{ $t('common.login') }}
          </button>
        </div>
      </section>
      <section v-if="!isMobile" class="header-main-menu-secondary"></section>
    </header>
    <div class="header-backdrop js-header-backdrop"></div>
    <client-only>
      <AuthModal
        ref="authModal"
        :layout="authModalSettings.selectedLayout"
        :menu="authModalSettings.selectedMenu"
        :has-img="authModalSettings.hasImg"
        :img-pc-src="(authBanner || {}).imgPath"
        :img-mobile-src="(authBanner || {}).mobileImgPath"
        :step="authModalSettings.hasStep"
        :has-sign-up-actual-name="true"
        :has-sign-up-confirm-password="true"
        :has-forget-pwd-tel-form="false"
        :has-email-verify-code="compCommon.signUp.emailVerifyCode.enable"
        :intel-countries="[defaultCountry]"
        :custom-username-rule="customUsernameRule"
        :close-default-src="
          'https://ik.imagekit.io/1pzxddx3qqv/mc/img/popup_close_btn_default.png'
        "
        :close-hover-src="
          'https://ik.imagekit.io/1pzxddx3qqv/mc/img/popup_close_btn_hover.png'
        "
        @loginSuccessAfter="loginSuccessAfter"
        @signUpSuccessAfter="signUpStepSuccessAfter('/user/inbox')"
        @openCSRWidget="openCSRWidget"
      >
      </AuthModal>
      <ThemeCustomizerAuthModal
        v-if="isDev"
        :settings="authModalSettings"
        @change="settings => (authModalSettings = settings)"
      />
      <GameSearchModal name="gameSearchModal" />
    </client-only>
  </section>
</template>

<script>
import { timer, empty, iif } from 'rxjs'
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  ref,
  useRoute,
  useStore,
  watch
} from '@nuxtjs/composition-api'
import AuthModal from '../../../components/AuthModal.vue'
import GameSearchModal from '../GameSearchModal'
import GlobalMessage from '../GlobalMessage'
import SlideModal from '../SlideModal'
import useUser from '../../../composables/useUser'
import useLocale from '../../../composables/useLocale'
import useTitle from '../../../composables/useTitle'
import usePrice from '../../../composables/usePrice'
import useLogout from '../../../composables/useLogout'
import useComp from '../../../composables/useComp'
import useCSR from '../../composables/useCSR'
import ThemeCustomizerAuthModal from '../../../components/ThemeCustomizerAuthModal.vue'
import useAuthModal from '../../../composables/useAuthModal'
import useErrorHandler from '../../../composables/useErrorHandler'
import SignUpForm from '../SignUpForm.vue'
import MainMenuContent from './MainMenuContent'
import MainMenuFooter from './MainMenuFooter'
import MainMenuHeader from './MainMenuHeader'
import HeaderMenu from './HeaderMenu.vue'

export default defineComponent({
  components: {
    SignUpForm,
    ThemeCustomizerAuthModal,
    HeaderMenu,
    MainMenuHeader,
    MainMenuContent,
    MainMenuFooter,
    GlobalMessage,
    SlideModal,
    AuthModal,
    GameSearchModal
  },
  setup(props, context) {
    const store = useStore()
    const route = useRoute()

    const showSwitchLocaleContent = ref(false)
    const mainMenuFirstList = ref([])

    const defaultCountry = computed(() => process.env.DEFAULT_COUNTRY)
    const isMobile = computed(() => store.state.isMobile)
    const { user, token, currencySymbol, maskUsername } = useUser(context)
    const templateId = computed(() => process.env.TEMPLATE_ID)
    const { loginSuccessAfter, signUpStepSuccessAfter } = useAuthModal(context)
    const { locale, locales, switchLocale } = useLocale()
    const { currency } = usePrice()
    const { openCSRWidget } = useCSR()
    const { errorHandler } = useErrorHandler(context)
    const {
      compCommon,
      compId,
      compName,
      isDev,
      compMainMenuSocialMediaList,
      compMainMenuFirstList,
      compMainMenuSecondaryGameList,
      compMainMenuSecondarySupportList,
      compMenuSecondaryWalletList
    } = useComp()
    const customUsernameRule = {
      required: true,
      regex: new RegExp(/^([A-Za-z][0-9A-Za-z]*)$/),
      min: 6,
      max: 15
    }

    const authModal = ref(null)
    const authModalSettings = ref({
      selectedLayout: 'A',
      hasImg: true,
      hasStep: true,
      selectedMenu: 'tabs'
    })

    const { title, getTitle } = useTitle()
    setTitle()
    watch([route, locale], () => {
      setTitle()
    })
    function setTitle() {
      const title = getTitle(route.value.path, store.state.locale)
      if (title) {
        store.commit('headerModule/TITLE', title)
      }
    }
    watch(route, value => {
      openLoginModalByQuery(value.query)
      openSignUpModalByQuery(value.query)
    })
    watch(isMobile, () => {
      resetHeaderBackdropHeight()
    })

    onMounted(() => {
      openLoginModalByQuery()
      openSignUpModalByQuery()
      mainMenuFirstFn()
      closeMainMenu()
    })

    const authBanners = computed(() => store.state.bannerModule.authBanners)
    const authBanner = computed(() => authBanners.value[0] || null)

    /**
     * 不使用 data-bs-dismiss="close" and data-bs-target="#headerMainSlideModal" 指定，
     * 而是使用 @click="closeMainSlideModal"，
     * 因為會有 href 失效的問題
     */
    // const headerMainSlideModal = ref(null)
    // function closeMainSlideModal() {
    //   headerMainSlideModal.value.hide()
    // }
    function back() {
      store.dispatch('headerModule/back')
    }
    function resetHeaderBackdropHeight(globalMessage) {
      if (globalMessage) {
        setTimeout(() => {
          $('.js-header-backdrop').css('height', $('.alert-warning').height())
          if (route.value.path.startsWith('/user')) {
            const headerAlertHeight = $('header .alert').innerHeight()
            $('.user-menu-header').css({
              top: headerAlertHeight,
              height: `calc(100% - ${headerAlertHeight}px)`
            })
          }
        }, 0)
      } else {
        $('.js-header-backdrop').css('height', '')
        if (route.value.path.startsWith('/user')) {
          $('.user-menu-header').css({ top: '', height: '' })
        }
      }
    }
    function closed() {
      store.commit('headerModule/SHOW_MENU_SWITCH_LOCALE_CONTENT', false)
    }
    function openLoginModalByQuery(query = route.value.query) {
      iif(
        () => !!query.openLoginModal && token.value === null,
        timer(0),
        empty()
      ).subscribe(() => showAuthModal('login', query.target))
    }
    function openSignUpModalByQuery(query = route.value.query) {
      iif(
        () => !!query.openSignUpModal && token.value === null,
        timer(0),
        empty()
      ).subscribe(() => showAuthModal('signUp'))
    }
    const { logout } = useLogout(context)

    function mainMenuFirstFn() {
      mainMenuFirstList.value = compMainMenuFirstList.value.filter(
        (item, idx, ary) => {
          return user.value ? item.type !== 'beginner' : item.type !== 'wallet'
        }
      )
    }
    function closeMainMenu() {
      nextTick(() => {
        const tabEl = $('[data-bs-toggle="tab"]')
        if (tabEl.hasClass('active')) {
          $(
            '[data-bs-toggle="tab"], .header-main-menu-content-list'
          ).removeClass('active show')
        }
      })
    }

    watch(user, () => {
      mainMenuFirstFn()
    })

    function capitalizeFirstWord(str) {
      return str.toLowerCase().replace(/^([a-z])/, g => {
        return g.toUpperCase()
      })
    }

    function showAuthModal(category) {
      getAuthBanner()
      nextTick(() => {
        if (authModal.value) {
          authModal.value.show(category)
        }
      })
    }

    function getAuthBanner() {
      store
        .dispatch('getAuthBanners', {
          tag: (route.value.query.source === 'lp' ? 'LP' : '') + 'SIGN'
        })
        .catch(err => errorHandler(err))
    }

    return {
      showSwitchLocaleContent,
      isMobile,
      user,
      maskUsername,
      templateId,
      locale,
      locales,
      title,
      currencySymbol,
      compCommon,
      compId,
      compName,
      isDev,
      customUsernameRule,
      compMainMenuSocialMediaList,
      compMainMenuSecondaryGameList,
      compMainMenuSecondarySupportList,
      compMenuSecondaryWalletList,
      compMainMenuFirstList,
      // headerMainSlideModal,
      mainMenuFirstList,

      defaultCountry,
      authModalSettings,
      authModal,
      authBanner,
      authBanners,
      showAuthModal,
      loginSuccessAfter,
      signUpStepSuccessAfter,
      switchLocale,
      // closeMainSlideModal,
      closeMainMenu,
      back,
      resetHeaderBackdropHeight,
      closed,
      currency,
      openCSRWidget,
      logout,
      capitalizeFirstWord
    }
  }
})
</script>
